import type { Category } from "@/models/types";

export const categories: Category[] = [
  { id: "cat-alimentacion", name: "Alimentación", icon: "ri-restaurant-2-line", color: "#22c55e" },
  { id: "cat-transporte", name: "Transporte", icon: "ri-car-line", color: "#14b8a6" },
  { id: "cat-entretenimiento", name: "Entretenimiento", icon: "ri-movie-2-line", color: "#f59e0b" },
  { id: "cat-compras", name: "Compras", icon: "ri-shopping-bag-3-line", color: "#f97316" },
  { id: "cat-servicios", name: "Servicios", icon: "ri-plug-line", color: "#ef4444" },
  { id: "cat-salud", name: "Salud", icon: "ri-heart-pulse-line", color: "#ec4899" },
  { id: "cat-educacion", name: "Educación", icon: "ri-book-open-line", color: "#84cc16" },
  { id: "cat-hogar", name: "Hogar", icon: "ri-home-4-line", color: "#eab308" },
  { id: "cat-otros", name: "Otros", icon: "ri-price-tag-3-line", color: "#64748b" },
];

export const CATEGORY_COLOR_PALETTE = [
  "#22c55e",
  "#14b8a6",
  "#f59e0b",
  "#f97316",
  "#ef4444",
  "#ec4899",
  "#84cc16",
  "#eab308",
  "#64748b",
  "#06b6d4",
  "#10b981",
  "#d946ef",
];

export const CATEGORY_ICON_OPTIONS = [
  "ri-restaurant-2-line",
  "ri-car-line",
  "ri-movie-2-line",
  "ri-shopping-bag-3-line",
  "ri-plug-line",
  "ri-heart-pulse-line",
  "ri-book-open-line",
  "ri-home-4-line",
  "ri-price-tag-3-line",
  "ri-gamepad-line",
  "ri-plane-line",
  "ri-gift-line",
  "ri-cup-line",
  "ri-smartphone-line",
  "ri-shirt-line",
  "ri-medicine-bottle-line",
];